<template>
  <div id="vrTestResults">
    <router-view class="mt-4"></router-view>
  </div>
</template>

<script>
  export default {
    name: 'vrTestResults',
  }
</script>
